import { render, staticRenderFns } from "./UcInvoiceGenerationInvoices.yaml?vue&type=template&id=6a7dccd7&component"
import script from "./UcInvoiceGenerationInvoices.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceGenerationInvoices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports